/**
 * Fix: ensure the Shopify cart session cookie is always sent/received on
 * AJAX cart requests (add to cart, cart refresh, etc.).
 *
 * The theme's fetch() calls do not explicitly set `credentials`, relying on
 * the browser's default. Some mobile browsers (e.g. Samsung Internet with
 * stricter privacy defaults) do not reliably default fetch() to
 * same-origin credentials, so the cart cookie set by /cart/add.js is not
 * sent on the follow-up /cart.js request, making the cart appear empty
 * even though the add succeeded server-side.
 *
 * Other third-party scripts on this site also monkey-patch window.fetch
 * for their own tracking, and can load after this file, overwriting the
 * patch with a plain assignment. Using Object.defineProperty as a guard
 * against that caused a conflict (a "Cannot assign to read only property"
 * exception in one of those scripts), so instead this re-applies a plain
 * wrap on initial load, again after window 'load' fires, and then keeps
 * re-checking every 2 seconds for the first 60 seconds after that — since
 * some third-party widgets (accessibility overlays, review/trust badges,
 * lead-tracking scripts) load asynchronously and can re-patch window.fetch
 * well after 'load'. This keeps our credentials fix as the outermost
 * wrapper without locking the property down for anyone else.
 */
(function () {
  function wrap(fn) {
    if (typeof fn !== 'function' || fn.__slipiWrapped) return fn;
    var wrapped = function (resource, init) {
      init = init || {};
      if (init.credentials === undefined) {
        init.credentials = 'same-origin';
      }
      return fn.call(this, resource, init);
    };
    wrapped.__slipiWrapped = true;
    return wrapped;
  }

  function applyPatch() {
    if (typeof window.fetch === 'function' && !window.fetch.__slipiWrapped) {
      window.fetch = wrap(window.fetch);
    }
  }

  applyPatch();

  if (document.readyState === 'complete') {
    applyPatch();
  } else {
    window.addEventListener('load', applyPatch);
  }

  // Guard window against late re-patching by third-party scripts (accessibility
  // widgets, review/trust badges, lead-tracking pixels, etc.) that load
  // asynchronously and can overwrite window.fetch well after 'load' fires.
  // Keep re-checking for the first 60 seconds, which comfortably covers
  // normal async script loading on this site.
  var reapplyCount = 0;
  var reapplyInterval = setInterval(function () {
    applyPatch();
    reapplyCount++;
    if (reapplyCount >= 30) {
      clearInterval(reapplyInterval);
    }
  }, 2000);
})();
